import React from "react";
import { useTranslation } from "react-i18next";
import {
  faExclamationTriangle,
  faRefresh,
} from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "./ErrorMessage.module.css";

interface ErrorMessageProps {
  message?: string;
  onRetry?: () => void;
  showRetry?: boolean;
}

export function ErrorMessage({
  message,
  onRetry,
  showRetry = true,
}: ErrorMessageProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.errorContainer}>
      <div className={styles.errorContent}>
        <FontAwesomeIcon
          icon={faExclamationTriangle}
          className={styles.errorIcon}
        />
        <div className={styles.errorText}>
          <h3>{t("error.title", "Något gick fel")}</h3>
          <p>
            {message ||
              t("error.generic", "Ett oväntat fel uppstod. Försök igen.")}
          </p>
        </div>
        {showRetry && onRetry && (
          <button
            className={styles.retryButton}
            onClick={onRetry}
            type="button"
          >
            <FontAwesomeIcon icon={faRefresh} />
            {t("error.retry", "Försök igen")}
          </button>
        )}
      </div>
    </div>
  );
}

export default ErrorMessage;
